'use client';

import React, { createContext, useContext } from 'react';

const NonceContext = createContext<string | undefined>(undefined);

export const NonceProvider = ({
    nonce,
    children,
}: {
    nonce: string;
    children: React.ReactNode;
}) => {
    return (
        <NonceContext.Provider value={nonce}>{children}</NonceContext.Provider>
    );
};

export const useNonce = () => {
    const context = useContext(NonceContext);
    if (context === undefined) {
        // Ideally we'd throw, but for dev robustness we might return undefined or empty
        // return '';
        throw new Error('useNonce must be used within a NonceProvider');
    }
    return context;
};
